import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Organization from "../views/Organization.vue";
import Meeting from "../views/Meeting.vue";
import Members from "../views/Members.vue";
import PublicScreen from "../views/PublicScreen.vue";

import store from "../store";
import Preregistrations from "@/views/Preregistrations";
import MeetingManualVotes from "../views/MeetingManualVotes";
import MeetingManualMemberVote from "../views/MeetingManualMemberVote";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Organization,
    meta: { auth: true }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { guest: true }
  },
  {
    path: "/organization/:orgId",
    name: "organization",
    component: Organization,
    meta: { auth: true }
  },
  {
    path: "/organization",
    name: "organizations",
    component: Organization,
    meta: { auth: true }
  },
  {
    path: "/manualvote/:meetingId/:electorSsn",
    name: "manualMemberVote",
    component: MeetingManualMemberVote,
    meta: { auth: true }
  },
  {
    path: "/manualvotes/:meetingId",
    name: "manualvotes",
    component: MeetingManualVotes,
    meta: { auth: true }
  },
  {
    path: "/meeting/:meetingId",
    name: "meeting",
    component: Meeting,
    meta: { auth: true }
  },
  {
    path: "/members/:meetingId",
    name: "members",
    component: Members,
    meta: { auth: true }
  },
  {
    path: "/preregistrations/:preregistrationId",
    name: "preregistrations",
    component: Preregistrations,
    meta: { auth: true }
  },
  // {
  //   path: "/invites/:meetingId",
  //   name: "invites",
  //   component: Invites,
  //   meta: { auth: true }
  // },
  {
    path: "/screen/:meetingId",
    name: "screen",
    component: PublicScreen,
    meta: { auth: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = !!store.state.auth.auth;
  if (to.meta.auth && !isLoggedIn) {
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else if (to.meta.guest && isLoggedIn) {
    next("/");
  } else {
    next();
    if (to.name !== "login") {
      // eslint-disable-next-line no-undef
      analytics.page("admin", to.name);
    }
  }
});

export default router;
